module.exports = __webpack_public_path__ + "img/2.2bf9b62.png";